export default {
  install(Vue, options) {
    const siteKey = options.siteKey;

    Vue.prototype.$executeRecaptcha = function (action) {
      return new Promise((resolve, reject) => {
        // Verificamos que el SDK de Enterprise esté cargado
        if (typeof window.grecaptcha === 'undefined' || typeof window.grecaptcha.enterprise === 'undefined') {
          reject(new Error('reCAPTCHA Enterprise no ha cargado.'));
          return;
        }

        window.grecaptcha.enterprise.ready(async () => {
          try {
            const token = await window.grecaptcha.enterprise.execute(siteKey, { action });
            resolve(token);
          } catch (error) {
            reject(error);
          }
        });
      });
    };
  }
};
